import { useEffect, useState } from 'react';

import { AutoResizeInput } from 'uiToolkitV1/AutoResizeInput';
import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';

type ViewViolationCommentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (comment: string) => void;
  isUpdating?: boolean;
};

export const ViewViolationCommentModal = ({ isOpen, onClose, onSave, isUpdating }: ViewViolationCommentModalProps) => {
  const [comment, setComment] = useState('');

  const handleSave = () => {
    onSave(comment);
  };

  // Reset comment when modal is closed
  useEffect(() => {
    if (!isOpen) {
      setComment('');
    }
  }, [isOpen]);

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      title="Add reason to deny"
      body={
        <AutoResizeInput
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Add comments here..."
          isDashed
          minH="224px"
          maxH="224px"
          _placeholder={{ color: 'text.g3' }}
        />
      }
      cancelText="Cancel"
      onCancel={onClose}
      continueText={isUpdating ? 'Saving...' : 'Save'}
      onContinue={handleSave}
      disabled={false}
      modalContentProps={{ w: '600px' }}
      cancelButtonProps={{}}
      continueButtonProps={{ disabled: comment.trim().length === 0 || isUpdating }}
    />
  );
};
